// extracted by mini-css-extract-plugin
module.exports = {"header":"EquipmentLeaseShowContainer_header__l6FlN"};